<template>
  <IonContent class="aha-content">
    <slot />
  </IonContent>
</template>

<script>
import { IonContent } from '@ionic/vue'

export default {
  components: {
    IonContent,
  },
}
</script>

<style lang="scss">
.aha-content {
  --background: transparent;
  --ion-background-color: transparent;
}
</style>
